// extracted by mini-css-extract-plugin
export default {"container":"style_container__h9cfI","title":"style_title__pyjX4"};